import { css } from '@emotion/react';
import { cssVarFuncFallback } from '../helpers';
import { darkThemeStyle } from '../theme';
import { tokens } from '../tokens';
import { ANIMATION_SPEED, LOADER_COLOR, LOADER_COLOR_VARIABLE, LOGOMARK_ANIMATION_SETTINGS, } from './constants';
import { logomarkEndMask, logomarkStartMask, logomarkStroke, spinnerRotate, } from './keyframes';
const wrapperStaticStyle = css({
    // Use the fallback of LOADER_COLOR, to set the initial color, for a single source of truth
    [LOADER_COLOR_VARIABLE]: cssVarFuncFallback(LOADER_COLOR),
});
const logomarkWrapperStaticStyle = css({
    animation: `${logomarkStartMask} cubic-bezier(0.65, 0, 0.55, 1) ${LOGOMARK_ANIMATION_SETTINGS}`,
    willChange: 'clip-path',
});
export const spinnerStaticStyle = css({
    animation: `${spinnerRotate} ${ANIMATION_SPEED} linear infinite`,
    background: `conic-gradient(from 0deg at 50% 50%, transparent 0deg, ${LOADER_COLOR} 360deg)`,
    borderRadius: tokens.borderRadius.circle,
    // Use an additional 0.5px to prevent a seam from appearing in the gradient
    mask: `radial-gradient(farthest-side, transparent calc(70% - 0.5px), ${LOADER_COLOR} calc(70% + 0.5px))`,
});
export function wrapperStyle({ height, inverted, width }) {
    return [
        ...(inverted ? [darkThemeStyle] : []),
        wrapperStaticStyle,
        css(Object.assign(Object.assign({}, (height !== undefined && css({ height }))), (width !== undefined && css({ width })))),
    ];
}
export function logomarkWrapperStyle({ height, inverted, width, }) {
    return [
        logomarkWrapperStaticStyle,
        wrapperStyle({ height, inverted, width }),
    ];
}
export const containerStaticStyle = css({
    animation: `${logomarkEndMask} cubic-bezier(0, 0, 0.85, 1) ${LOGOMARK_ANIMATION_SETTINGS}`,
    willChange: 'clip-path',
});
export const svgWrapperStaticStyle = css({
    clipPath: 'polygon(-0.1% -10%, 169% 65%, -0.1% 139%)',
});
export const loaderSvgStaticStyle = css({
    display: 'block',
    overflow: 'visible',
    stroke: LOADER_COLOR,
});
export const loaderPathStaticStyle = css({
    animation: `${logomarkStroke} cubic-bezier(0.65, 0, 0.55, 1) ${LOGOMARK_ANIMATION_SETTINGS}`,
    strokeDasharray: 9800,
    strokeDashoffset: 9800,
    willChange: 'stroke-dashoffset',
});
